import orderBy from 'lodash/orderBy'

export const MAX_RELATED_PRODUCT_RESULTS = 20

export const CATALOG_SOURCE_LABELS = {
  premium: 'Premium',
  outlet: 'Outlet',
}

export const formatRelatedProductLabel = (product) => product.name

export const formatRelatedProductMeta = (product) => {
  const parts = []

  if (product.brandName) {
    parts.push(product.brandName)
  }

  if (product.barcode) {
    parts.push(`Штрихкод: ${product.barcode}`)
  }

  return parts.join(', ')
}

/** Прибирає пунктуацію/зайві пробіли, щоб "Dr.Solution" ≈ "Dr. Solution". */
export const normalizeRelatedProductSearchText = (value) =>
  String(value || '')
    .toLowerCase()
    .replace(/[^\p{L}\p{N}]+/gu, ' ')
    .trim()
    .replace(/\s+/g, ' ')

const matchesQuery = (product, query) => {
  const tokens = normalizeRelatedProductSearchText(query).split(' ').filter(Boolean)

  if (tokens.length === 0) {
    return true
  }

  const haystack = normalizeRelatedProductSearchText(
    [product.name, product.barcode, product.brandName].filter(Boolean).join(' ')
  )

  return tokens.every((token) => haystack.includes(token))
}

const matchesSubcategoryIds = (product, subcategoryIds) =>
  subcategoryIds.some((subcategoryId) => String(subcategoryId) === String(product.subcategoryId))

export const isProductMatchingFilters = (product, filters) => {
  if (!filters.catalogSources.includes(product.source)) {
    return false
  }

  if (filters.brandIds.length > 0 && !filters.brandIds.includes(product.brandId)) {
    return false
  }

  if (filters.categoryIds?.length > 0 && !filters.categoryIds.includes(product.categoryId)) {
    return false
  }

  if (filters.subcategoryIds?.length > 0) {
    if (!product.subcategoryId || !matchesSubcategoryIds(product, filters.subcategoryIds)) {
      return false
    }
  }

  return true
}

export const hasBrowsableProductScope = (filters = {}) => {
  if (!filters.brandIds?.length) {
    return false
  }

  return Boolean(filters.categoryIds?.length > 0 || filters.subcategoryIds?.length > 0)
}

const mapProductResults = (products) =>
  products.map((product) => ({
    ...product,
    label: formatRelatedProductLabel(product),
    metaLabel: formatRelatedProductMeta(product),
    sourceLabel: CATALOG_SOURCE_LABELS[product.source],
  }))

const filterRelatedProducts = (index = [], filters, query, { allowBrowseWithoutQuery = false } = {}) => {
  const trimmedQuery = (query || '').trim()
  const list = Array.isArray(index) ? index : []

  if (!trimmedQuery && !allowBrowseWithoutQuery) {
    return []
  }

  let filtered = list.filter((product) => isProductMatchingFilters(product, filters))

  if (trimmedQuery) {
    filtered = filtered.filter((product) => matchesQuery(product, trimmedQuery))
  }

  return orderBy(filtered, ['name'], ['asc'])
}

export const countFilteredRelatedProducts = (index = [], filters, query, options = {}) =>
  filterRelatedProducts(index, filters, query, options).length

export const searchRelatedProducts = (index = [], filters, query, options = {}) => {
  const filtered = filterRelatedProducts(index, filters, query, options)

  return mapProductResults(filtered.slice(0, MAX_RELATED_PRODUCT_RESULTS))
}

export const getBrowsableProductScope = (index = [], filters) =>
  searchRelatedProducts(index, filters, '', { allowBrowseWithoutQuery: hasBrowsableProductScope(filters) })

export default searchRelatedProducts
